<template>
<!-- eslint-disable max-len -->
<div
  class="eula-prompt animated fadeIn"
>
  <div style="display: flex; flex-flow: row nowrap; justify-content: space-between; align-items: flex-start;">
    <h2>
      Please accept EULA to continue
    </h2>
    <a href="" @click.prevent="close" class="btn btn-sm" style="font-size: 1.5rem;">
      &times;
    </a>
  </div>

  <div class="eula-text" v-if="!customEula">
END USER LICENSE AGREEMENT<br/>
IMPORTANT INFORMATION – PLEASE READ CAREFULLY<br/>
The herein contained License Agreement ("License" or "EULA") shall be considered a legally binding agreement between You (as an individual or an entity, who then shall, within the constraints of this agreement, be referred to as "You" or "Your") and for the use of the specified software application hosted on the B.L.A.D.E. Platform, which may include related printed material, media and any other components and/or software modules, including but not limited to required drivers ("Product"). Other aspects of the Product may also include, but are not limited to, software updates and any upgrades necessary that may supply to You or make available to You, or that You could obtain after the initial copy of the Product, and as such that said items are not accompanied by a separate license agreement or terms of use.<br/>
<br/>
<br/>
BY WAY OF THE INSTALLATION, COPYING, DOWNLOADING, ACCESSING OR OTHERWISE USE OF THIS PRODUCT, YOU ARE AGREEING TO BE LEGALLY BOUND BY THE HEREIN CONTAINED TERMS OF THIS LICENSE AGREEMENT. IF YOU DO NOT AGREE TO BE BOUND BY THE TERMS OF THIS EULA, YOU THEN HAVE NO RIGHTS TO THE PRODUCT AND SHOULD THEREFORE NOT INSTALL, COPY, DOWNLOAD, ACCESS NOR USE THE PRODUCT.<br/>
<br/>
<br/>
This Product is hereby protected by copyright laws, as well as any other intellectual property laws. This Product is licensed and not sold.<br/>
<br/>
LICENSE GRANT<br/>
We shall grant to you a non-exclusive license for the use and installation of the Product subject to all the terms and conditions set forth herein. Furthermore, this EULA shall also govern any and all software upgrades provided by that would replace, over write and/or supplement the original installed version of the Product, unless those other upgrades are covered under a separate license, at which those terms of that license will govern.<br/>
<br/>
TERMINATION<br/>
Should you breach this EULA at any time, your right to the use of the Product will then immediately terminate and shall terminate without any notice being given. However, all provisions of this EULA, with the exception of the License Grant, will remain in effect and thus shall survive termination. Upon termination of the License Grant, You MUST destroy any and all copies of the Product.<br/>
<br/>
COPYRIGHT<br/>
The aforementioned Product is protected by copyright and other intellectual property laws and treaties, and as such all rights, title, and interest in and to the content offered, including but not limited to, any photographs, images, video animation, text, and music, that may be incorporated as part of the offered content. Such offered content is protected by copyright laws and international treaty provisions. Therefore, offered content must be treated as any other copyrighted material, with the exception that it is allowable for you to make copies as provided by the License. However, printed material, which may accompany any offered content, may not be copied.<br/>
<br/>
RESTRICTIONS ON USE<br/>
As a Licensee, You may not:<br/>
&bull;  (a) Make use of the offered content on more than one computer at a time, without prior purchase of additional licenses;<br/>
<br/>
&bull;  (b) You may not share, distribute, lend, lease, sublicense or otherwise make available, in any manner whatsoever, to any third party the offered content;<br/>
<br/>
&bull;  (c) Modify, adapt, create derivative works from or translate any part of the offered content other than what may be used within Your work in accordance with this License;<br/>
<br/>
&bull;  (d) Reverse engineer, decompile or disassemble the offered content, nor attempt to locate or obtain its source code;<br/>
<br/>
&bull;  (e) Attempt to alter or remove any trademark, copyright or other proprietary notice contained within the offered content; or<br/>
<br/>
&bull;  (f) Make use of any offered content in any manner not stipulated within this EULA or the documentation accompanying the offered content.<br/>
<br/>
UPDATES<br/>
We may find the need from time to time to make available to all license holders updates for the offered content, in accordance with the herein contained terms and conditions of this EULA. It shall be at the sole discretion of to make conditional releases of said upgrade to you upon your acceptance of another EULA or execution of another separate agreement. Should you elect to install and make use of these updates, you are therefore agreeing to be subject to all applicable license, terms and conditions of this EULA and/or any other agreement.<br/>
<br/>
DISCLAIMER OF WARRANTY<br/>
With regard and with relationship to the maximum extent permitted by applicable law, you, and, if applicable, related suppliers, shall provide the Product and any support services, if needed, related to the Product, and hereunto disclaim all warranties and conditions, either express, implied or statutory, which may include, but are not limited to, any implied warranties or conditions of merchantability, of suitability for a specified purpose, that it contains absolute accuracy or completeness of responses, of results, and of any lack of negligence or lack of workmanlike effort, all with respect to the Product, and the provision of or failure to provide Support Services. FURTHERMORE, THERE IS NO WARRANTY OR CONDITION OF TITLE, QUIET ENJOYMENT, QUIET POSSESSION, OR NON-INFRINGEMENT WITH REGARDS TO THE HEREIN CONTAINED PRODUCT. THE ENTIRE RISK AS TO THE QUALITY OF OR PERFORMANCE OF THE PRODUCT AND SUPPORT SERVICES, IF ANY, REST WITH YOU.<br/>
<br/>
LIMITATION OF LIABILITY AND REMEDIES<br/>
In spite of any damages that you may or may not incur for any reason, which may include, but are not limited to, any and all direct or general damages, the entire liability of and/or any of the aforementioned suppliers covered under the herein contained provisions of this EULA, along with Your exclusive remedy with regards to all of the foregoing, shall hereby be limited to the amount actually paid by you for this Product. Therefore, the aforementioned limitations, exclusions and any disclaimers shall apply to the maximum extent allowable by law, even should any proposed remedy fail its essential purpose.<br/>
<br/>
EXPORT CONTROLS<br/>
By clicking on the install button, you hereby agree that you will comply with any and all applicable export laws, restrictions and all regulations of the U.S. Department of Commerce, U.S. Department of Treasury, and any other U.S. or foreign agency or authority with regards to this provision of the EULA. You expressly agree not to export or re-export, nor allow the export or re-export of the offered content in violation of any such law, restriction or regulation, including without limitation, export or re-export to any country subject to any and all applicable U.S. trade embargoes or to any prohibited destination, in any group specified in the current "Supplement No. 1 to Part 740 or the Commerce Control List specified in the then current Supplement No. 1 to Part 738 of the U.S. Export Administration Regulations (or any successor supplement or regulations)."<br/>
<br/>
U.S. GOVERNMENT END USERS<br/>
The offered content is licensed by the U.S. Government with RESTRICTED RIGHTS. The use, duplication of, or the disclosure by the U.S. Government, shall be subject to restrictions in accordance with DFARS 252.227-7013 of the Technical Data and Computer Software clause, and 48 DCR 52.227-19 of the Commercial Computer Software clause, as applicable.<br/>
<br/>
MISCELLANEOUS<br/>
This EULA, in its entirety, shall be legally binding upon and inure to the benefit of and you, our respective successors and permitted assigns. Should any of this provision be deemed invalid or unenforceable, such determination will not affect the validity or enforceability of any other provision contained herein. If there is any waiver of any breach or failure to enforce any of the provisions contained herein, it shall not be deemed as a future waiver of said terms or a waiver of any other provision of this EULA. Any waiver, supplementation, modification or amendment to any provision of this EULA, shall only be effective when done so in writing and signed off by and you. This EULA shall be governed solely by the laws of the State of Texas and of the United States. Should any action arise out of or in relation to this EULA, such action may be brought exclusively in the appropriate federal or state court in Austin, Texas, and as such, you and irrevocably consent to the jurisdiction of said court and venue for Austin, Texas.<br/>
  </div>
  <div class="eula-text eula-frame-container" v-else>
    <iframe :src="customEula" title="Custom EULA" class="custom-eula-frame" />
  </div>

  <div style="display: flex; flex-flow: row nowrap; justify-content: space-between; align-items: flex-end;">
    <button
      class="btn"
      @click.prevent.once="close">
      Close
    </button>
    <button
      class="btn"
      @click.prevent.once="accept">
      Accept EULA
    </button>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import catalogPurchaseTarget from '../../../utils/catalog';

export default {
  props: {
    customEulaURL: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      customEula: null
    };
  },
  computed: {
    ...mapGetters([
      'me',
      'activeRegistrationLink'
    ])
  },
  methods: {
    ...mapActions([
      'updateMe',
      'logout'
    ]),
    async accept() {
      this.me.eulaAccepted = true;
      await this.updateMe(this.me);
      const target = await catalogPurchaseTarget(this.$store, this.me);
      if (target) {
        this.$router.replace(target);
        return;
      }
      this.$router.home();
    },
    async close() {
      await this.logout();
      this.$emit('noaccept');
    }
  },
  mounted() {
    if (this.me.registrationLinkUsed && this.me.registrationLinkUsed.customEulaUrl) {
      this.customEula = (this.me.registrationLinkUsed.customEulaUrl || '').trim();
    } else if (this.customEulaURL) {
      this.customEula = this.customEulaURL.trim();
    } else if (this.activeRegistrationLink && this.activeRegistrationLink.customEulaUrl) {
      this.customEula = (this.activeRegistrationLink.customEulaUrl || '').trim();
    }
  }
};
</script>

<style lang="scss" scoped>
.eula-prompt {
  background-color: rgba(0, 0, 7, 0.76);
  color: white;
  padding: 15px;
  transition: all .15s linear;
  position: absolute;
  width: 64vw;
  height: 66vh;
  bottom: 0;
  left: calc(50% - 32vw);
  z-index: 1000;
  display: flex;
  flex-flow: column nowrap;
}
.eula-text {
  overflow: auto;
  flex-basis: calc(66vh - 200px);
  flex-grow: 10;
  width: 100%;
  margin-bottom: 10px;
}
.eula-frame-container {
  overflow: hidden;
}
.custom-eula-frame {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/modals/EULAPrompt.vue